export default __webpack_public_path__ + "static/media/bossy.5d3a89cc.png";